<template>
  <v-layout row align-center justify-space-between class="farm-shipment-item">
    <v-flex class="my-2" grow>
      <div v-if="getFarm(shipment.location)" class="font-weight-bold label my-1">{{getFarm(shipment.location).name}}</div>
      <div class="font-weight-regular name my-1">{{shipment.id}}</div>
    </v-flex>
    <v-flex shrink>
      <v-layout column align-end justify-center>
        <div v-if="!shipment.processed_at" class="font-weight-bold text-capitalize status my-1 pending">Pending</div>
        <div v-if="shipment.processed_at" class="font-weight-bold text-capitalize status my-1 processed">Processed</div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'ShipmentItem',
  props: ['shipment'],
  computed: mapGetters({
    getFarm: 'getFarm'
  })
}
</script>

<style lang="scss" scoped>
.label{
  font-size: 11px;
}

.name{
  font-size: 16px;
}

.status{
  font-size: 16px;
}

.pending{
  color: #65bbef;
}

.processed{
  color: #378e07;
}

</style>
